import {
    EVENT_LIST_REQUEST,
    EVENT_LIST_SUCCESS,
    EVENT_LIST_FAIL,
    EVENT_ADD_REQUEST,
    EVENT_ADD_SUCCESS,
    EVENT_ADD_FAIL,
    EVENT_ADD_RESET,
  } from "../Constants/EventConstants";
  
  // Event list reducer
  export const eventListReducer = (state = { events: [] }, action) => {
    switch (action.type) {
      case EVENT_LIST_REQUEST:
        return { loading: true, events: [] };
      case EVENT_LIST_SUCCESS:
        return { loading: false, events: action.payload };
      case EVENT_LIST_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Event add reducer
  export const eventAddReducer = (state = {}, action) => {
    switch (action.type) {
      case EVENT_ADD_REQUEST:
        return { loading: true };
      case EVENT_ADD_SUCCESS:
        return { loading: false, success: true, event: action.payload };
      case EVENT_ADD_FAIL:
        return { loading: false, error: action.payload };
      case EVENT_ADD_RESET:
        return {};
      default:
        return state;
    }
  };